export default __webpack_public_path__ + "static/media/StepOne.bb2bc3f6.svg";